import { ReactNode } from "react";

import { cn } from "../utils/styling";
import { asterisk } from "../utils/textSymbols";

export const FormRowLabel = ({
  className,
  label,
  required,
}: {
  className?: string;
  label: ReactNode;
  required?: boolean;
}) => {
  return (
    <span className={cn("font-ds-body-bold-md", className)}>
      {label} {required ? <span className="text-core-mystic-red-400">{asterisk}</span> : null}
    </span>
  );
};
